import { queryAll, query, fromId } from '../utils/utils.js';

export class Level2Headline {


    constructor() {

        // strip empty paragraphs
        queryAll('.level2-headline').forEach(( l2h ) => {
            l2h.querySelectorAll('p').forEach(( p ) => {
                if ( p.innerHTML === '' ) {
                    p.remove();
                }
            });
        });

    }

}